import React from "react";

import { withFilterSectionRange } from "./withFilterSectionRange";

import { Range } from "@bared/ui";

export const FilterSectionRange = withFilterSectionRange(
  ({ options, handleChange }) => (
    <Range options={options} handleChange={handleChange} />
  ),
);
